export default __webpack_public_path__ + "static/media/MonthlyAverageIcon.6bf868c7.svg";